export enum SnackbarType {
  ERROR = "ERROR",
  INFO = "INFO"
}

export const SnackbarMessage = new Map<SnackbarType, string>([
  [SnackbarType.ERROR, "Error occured"],
  [SnackbarType.INFO, "Information messsage"]
]);
